import { axiosInstanceWhatsAppConfirmation } from "../instance";

// Shared order-confirmation contracts. The retired `/chat` workspace used to
// live in this service too; only contracts still consumed by Orders,
// Integrations, realtime setup, and abandoned-cart recovery remain here.

export type ConfirmationStatus =
  | "pending"
  | "awaiting_response"
  | "confirmed"
  | "rejected"
  | "expired"
  | "canceled"
  | "send_failed";

export interface ConfirmationInfo {
  status: ConfirmationStatus;
  confirmation_id: number;
  ai_enabled: boolean;
}

export const getConfirmationStatuses = async (
  ownerId: string,
  orderIds: number[]
): Promise<Record<string, ConfirmationInfo>> => {
  if (orderIds.length === 0) return {};
  const response = await axiosInstanceWhatsAppConfirmation.post(
    "/admin/confirmations/batch-status",
    { owner_id: ownerId, order_ids: orderIds }
  );
  return response.data.statuses;
};

export const updateShippingAddress = async (
  confirmationId: number,
  addressData: { address?: string; addressDetail?: string; city?: string; department?: string }
): Promise<{ status: string; fields: string[] }> => {
  const response = await axiosInstanceWhatsAppConfirmation.put(
    `/admin/confirmations/${confirmationId}/update-address`,
    addressData
  );
  return response.data;
};

export interface WhatsAppOAuthCallbackRequest {
  code: string;
  phone_number_id: string;
  waba_id: string;
  owner_id: string;
}

export interface WhatsAppOAuthCallbackResponse {
  status: string;
  owner_id: string;
  phone_number_id: string;
  waba_id: string;
  verify_token: string;
}

export const whatsappOAuthCallback = async (
  data: WhatsAppOAuthCallbackRequest
): Promise<WhatsAppOAuthCallbackResponse> => {
  const response = await axiosInstanceWhatsAppConfirmation.post(
    "/admin/whatsapp-accounts/oauth/callback",
    data
  );
  return response.data;
};

export interface RealtimeConfig {
  env: string;
  firebase_prefix: string;
}

export const getRealtimeConfig = async (): Promise<RealtimeConfig> => {
  const response = await axiosInstanceWhatsAppConfirmation.get(
    "/admin/realtime-config"
  );
  return response.data;
};

export interface RecoverAbandonedCartProduct {
  name?: string | null;
  units?: number | null;
  total_value_with_discount?: number | null;
  product_id?: string | null;
}

export interface RecoverAbandonedCartRequest {
  owner_id: string;
  phone: string;
  customer_name?: string | null;
  funnel_name?: string | null;
  products: RecoverAbandonedCartProduct[];
}

export interface RecoverAbandonedCartResponse {
  status: string;
  phone: string;
  template_name: string;
  wa_message_id: string;
}

export const recoverAbandonedCart = async (
  payload: RecoverAbandonedCartRequest
): Promise<RecoverAbandonedCartResponse> => {
  const response = await axiosInstanceWhatsAppConfirmation.post(
    "/admin/abandoned-carts/recover",
    payload
  );
  return response.data;
};
